import React from "react";
import { usePermissions } from "../../hooks/usePermissions";

interface PermissionGateProps {
  permission?: string | string[];
  children: React.ReactNode;
  checkCountryAndModuleAccess?: boolean; // Check both country access and module permission
  checkCountryLevelAccessOnly?: boolean; // Only check country access
  checkModuleLevelAccessOnly?: boolean; // Only check module permission
  hasCountryLevelAccess?: boolean; // Pass the country access status true/false
}

const PermissionWrapper: React.FC<PermissionGateProps> = ({
  permission = "",
  children,
  checkCountryAndModuleAccess = false,
  checkCountryLevelAccessOnly = false,
  hasCountryLevelAccess = false,
}) => {
  const { hasModulePermission } = usePermissions();

  const renderContent = (isVisible: boolean) =>
    isVisible ? <>{children}</> : null;

  // Helper to check if user has any of the provided permissions
  const hasAnyPermission = (perm: string | string[]): boolean => {
    if (Array.isArray(perm)) {
      return perm.some((p) => hasModulePermission(p));
    }
    return hasModulePermission(perm);
  };

  // 1. Check both module permission and country access (default)
  if (checkCountryAndModuleAccess) {
    const hasPermission = hasAnyPermission(permission);
    const hasCountryAccess = hasCountryLevelAccess;

    return renderContent(hasPermission && hasCountryAccess);
  }

  // 2. Only check country access
  if (checkCountryLevelAccessOnly) {
    return renderContent(hasCountryLevelAccess);
  }

  // 3. default check module level permission
  return renderContent(hasAnyPermission(permission));
};

export default PermissionWrapper;
